import styled, { keyframes } from "styled-components";

const rise = keyframes`
0% {
     margin-top: -17px;
  }
  100% {
    margin-top: 5px;
   }
`;

export const Coefficient = styled.div`
  text-align: center;
  height: 22px;
  animation: ${rise} 0.06s linear forwards;
  bottom: 0;
  margin-top: 5px;
  background-color: ${({ bcc }) => bcc};
  border-radius: 10px;
  color: #353752;
  opacity: ${({ length, index }) => (index + 2) / length}};
`;

export const WheelDiv = styled.div`
  position: absolute;
  top: 60px;
  right: 0px;
  width: 40px;
  height: 165px;
  overflow: hidden;
`;

export const AnimaDiv = styled.div`
  display: flex;
  flex-direction: column-reverse;
`;
